import React from "react";
import { elakayAutoText } from "../../pageInside/dataElakay";
import FilterValuePicker from "../../pageInside/filters/FilterValuePicker";
import SellerFilterCombinationsEditor from "./SellerFilterCombinationsEditor";
import "../../dropshippingInterne/provider/ProviderProductWizard.css";

export default function SellerFilterEditor({ editor, infoSource, onContinue, quantityLocked = false }) {
  const {
    combinationRows, filterDefs, activeDefs, sellerSelectedValues,
    onToggleFilterValue, onToggleAllFilterValues,
    onCombinationFieldChange, onCombinationQuantityChange, onCombinationPriceChange,
    onAddCombinationRow, onRemoveCombinationRow, duplicateRowIds, incompleteRowIds,
    filterComboError, filterComboMessage, savingFilterCombinations, filterSaveNeedsReload,
    saveFilterCombinations, canSave,
  } = editor;
  return <fieldset disabled={savingFilterCombinations} className="seller-filter-combinations-controls provider-filters">
              <h4 className="section-subtitle">{elakayAutoText("h_seller_linked_category_filters_title", "Filters from your linked categories")}</h4>
              <small className="text-muted d-block mb-2">{elakayAutoText("h_seller_linked_category_filters_hint", "Filters and values come from your categories.")}</small>
              {filterDefs.length === 0 ? (
                <p className="text-muted">{elakayAutoText("h_seller_no_filters_available", "No filters available for the selected category.")}</p>
              ) : (
                <FilterValuePicker
                  defs={filterDefs}
                  selected={sellerSelectedValues}
                  onToggleValue={onToggleFilterValue}
                  onToggleAll={onToggleAllFilterValues}
                  selectAllLabel={elakayAutoText("h_seller_select_all", "Select all")}
                />
              )}

              {filterComboError && <p role="alert" className="seller-filter-combo-error">{filterComboError}</p>}
              {filterComboMessage && <p role="status" className="text-success">{filterComboMessage}</p>}

              <h4 className="section-subtitle mt-3">{elakayAutoText("h_seller_filter_combinations_title", "Filter combinations")}</h4>
              <SellerFilterCombinationsEditor
                activeDefs={activeDefs}
                disabled={savingFilterCombinations}
                quantityLocked={quantityLocked}
                rows={combinationRows}
                onFieldChange={onCombinationFieldChange}
                onQuantityChange={onCombinationQuantityChange}
                onPriceChange={onCombinationPriceChange}
                onRemoveRow={onRemoveCombinationRow}
                onAddRow={onAddCombinationRow}
                duplicateRowIds={duplicateRowIds}
                incompleteRowIds={incompleteRowIds}
                labels={{
                  quantity: infoSource.laguangeElakay('sellPage', infoSource.languageAPI).quantity,
                  price: elakayAutoText("h_seller_combo_price", "Price"),
                  selectPlaceholder: infoSource.laguangeElakay('label', infoSource.languageAPI).pleaseSelect,
                  addCombination: elakayAutoText("h_seller_add_combination", "+ Add combination"),
                  removeCombination: elakayAutoText("h_seller_remove_combination", "Remove combination"),
                  duplicateError: elakayAutoText("h_seller_duplicate_combination", "This filter combination already exists."),
                  incompleteError: elakayAutoText("h_seller_invalid_combination_row", "Select each filter, a whole quantity of 0 or more, and a valid non-negative price."),
                  noActiveFilters: filterDefs.length === 0
                    ? elakayAutoText("h_seller_no_category_filters_stock", "This category has no filters. Add one stock row to continue.")
                    : elakayAutoText("h_seller_no_active_filters", "Check at least one value above in \"Filters from your linked categories\" to start building combinations."),
                  quantityLockedHint: elakayAutoText("h_seller_quantity_locked_provider", "Synced from the Provider -- use Resynchronize to update it."),
                }}
              />

              <div className="form-actions mt-3">
                <button type="button" className="btn btn-primary btn-primary-modern" aria-busy={savingFilterCombinations} disabled={savingFilterCombinations || filterSaveNeedsReload || !canSave} onClick={saveFilterCombinations}>
                  {elakayAutoText("h_seller_save_filter_changes", "Save Filter Changes")}
                </button>
                {onContinue && <button type="button" className="btn btn-primary" disabled={savingFilterCombinations || filterSaveNeedsReload || !canSave} onClick={onContinue}>
                  {infoSource.laguangeElakay('Button', infoSource.languageAPI).next}
                </button>}
              </div>
  </fieldset>;
}
